import { DataSource } from '@angular/cdk/table';

export abstract class NbDataSource<T> extends DataSource<T> {}
